import { styled } from 'buttered';

export let ModalContent = styled('main')`
  padding: 15px 20px 20px 20px;
  flex-grow: 1;
`;
